import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GeneralLedgerInterface } from 'src/app/accountancy/utilities/interfaces/global.interface';
import { LocalStorageApiService } from 'src/app/accountancy/utilities/services/local-storage-api/local-storage-api.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralLedgerItemService {

  constructor(
    private _localStorageS: LocalStorageApiService,
  ) { }

  public readonly item$ = new BehaviorSubject<undefined | null | GeneralLedgerInterface>(this._localStorageS.object.get('gl-item'));

  public next(item: GeneralLedgerInterface) {
    this.item$.next(item);
    this._localStorageS.object.set('gl-item', item);
  }

  public getValue() {
    return this.item$.getValue();
  }


}
